import { Info } from "lucide-react";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { SubscribeDialog } from "@/components/billing/SubscribeDialog";
import { usePortfolio } from "@/contexts/PortfolioContext";
import { useT } from "@/lib/translation";

/** Shown above a paid feature while a free user tries it on the demo portfolio. */
export function DemoPreviewBanner() {
  const { lastRealPortfolioId, setSelectedPortfolioId } = usePortfolio();
  const t = useT();

  // The icon sits inside the row, not in Alert's absolute icon slot, so it stays centred
  // with the text next to the buttons.
  return (
    <Alert className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3 text-sm">
        <Info className="h-4 w-4 shrink-0" />
        <span>{t("billing:demoBanner.message")}</span>
      </div>
      <div className="flex shrink-0 gap-2">
        {lastRealPortfolioId !== null && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setSelectedPortfolioId(lastRealPortfolioId)}
          >
            {t("billing:demoBanner.backToPortfolio")}
          </Button>
        )}
        <SubscribeDialog>
          <Button size="sm">{t("billing:actions.subscribe")}</Button>
        </SubscribeDialog>
      </div>
    </Alert>
  );
}
